import { CSSObject } from '@emotion/react';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { IComponentCss } from '../styles';

/*
*   Линейный график прогресса
*/


export type LinearProgressChartProps = {
    value: number,
    colorPrimary?: string,
    colorBar?: string,
    chartStyle?: CSSObject,
}

const css: IComponentCss = {
    chart: {
        height: 10,
        borderRadius: 4,
        [`& .${linearProgressClasses.bar}`]: {
            borderRadius: 4,
        },
    },
}

export const LinearProgressChart = ({
    value,
    colorPrimary = '#ebebeb',
    colorBar = '#2196f3',
    chartStyle = {},
}: LinearProgressChartProps) => {

    return (
        <LinearProgress
            variant='determinate'
            value={value}
            sx={{
                ...css.chart,
                ...chartStyle,
                [`&.${linearProgressClasses.colorPrimary}`]: {
                    backgroundColor: colorPrimary,
                },
                [`& .${linearProgressClasses.bar}`]: {
                    backgroundColor: colorBar,
                },
            }}
        />
    );
}
